import React, { useState } from 'react';
import {
  getFbButtonUrl,
  getTwUrl,
  getVkUrl,
  getOkUrl,
  getWhatsappUrl,
  getTelegramUrl,
} from 'vanilla-sharing';

import SharingIcon from '../../icons/Sharing';
import VkIcon from '../../icons/Vk';
import FacebookIcon from '../../icons/Fb';
import Tw from '../../icons/Tw';
import OkIcon from '../../icons/Ok';
import WhatsAppIcon from '../../icons/Wa';
import TelegramIcon from '../../icons/Telegram';

import defaultImage from '../../images/sixstories.jpg';
import vkImage from '../../images/sixstories-vk.jpg';

import sharingStyle from './sharing.module.css';

const url = 'https://sixstories.baza.io';
const title = '6 откровенных историй людей, которые смотрят порно';

const SOCIAL_LINKS = [
  {
    icon: <FacebookIcon />,
    label: 'Поделиться в фейсбукe',
    url: getFbButtonUrl({ url }),
  },
  {
    icon: <VkIcon />,
    label: 'Поделиться в вконтакте',
    url: getVkUrl({ url, title, image: `https://sixstories.baza.io${vkImage}` }),
  },
  {
    icon: <Tw />,
    label: 'Поделиться в твиттере',
    url: getTwUrl({ url, title }),
  },
  {
    icon: <TelegramIcon />,
    label: 'Поделиться в телеграмме',
    url: getTelegramUrl({ url, title }),
  },
  {
    icon: <WhatsAppIcon />,
    label: 'Поделиться в вотсапе',
    url: getWhatsappUrl({ url, title }),
  },
  {
    icon: <OkIcon />,
    label: 'Поделиться в одноклассниках',
    url: getOkUrl({ url, title, image: `https://sixstories.baza.io${defaultImage}` }),
  },
];

const Sharing = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`${sharingStyle.sharing} ${props.light && sharingStyle.sharingLight}`}>
      <button
        type="button"
        className={sharingStyle.button}
        onClick={() => {setIsOpen(true)}}
      >
        <SharingIcon />
      </button>

      {isOpen && (
        <React.Fragment>
          <div
            className={sharingStyle.sharingPopup}
            area-label="backdrop"
            onClick={() => {setIsOpen(false)}}
          />

          <div className={sharingStyle.sharingBody}>
            <div className={sharingStyle.sharingLinksWrapper}>
              {SOCIAL_LINKS.map(item => (
                <a
                  key={item.label}
                  className={sharingStyle.sharingLink}
                  aria-label={item.label}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.icon}
                </a>
              ))}
            </div>

            <button
              className={sharingStyle.buttonActive}
              onClick={() => {setIsOpen(false)}}
            >
              <SharingIcon />
            </button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

export default Sharing;
